import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("p", {
    class: _normalizeClass(["ds-caption", [`ds-caption--size_${$props.size}`]])
  }, [
    _createTextVNode(_toDisplayString($props.text) + " ", 1),
    _createElementVNode("a", {
      class: _normalizeClass(["ds-link ds-link--inline", [`ds-link--size_${$props.size}`, $props.linkClass]]),
      href: $setup.privacyPolicyUrl,
      target: "_blank"
    }, _toDisplayString(_ctx.$t("політикою конфіденційності")), 11, _hoisted_1),
    _createTextVNode(" " + _toDisplayString(_ctx.$t("та")) + " ", 1),
    _createElementVNode("a", {
      class: _normalizeClass(["ds-link ds-link--inline", [`ds-link--size_${$props.size}`, $props.linkClass]]),
      href: $setup.termsOfUseUrl,
      target: "_blank"
    }, _toDisplayString(_ctx.$t("правилами сайта")), 11, _hoisted_2)
  ], 2))
}